import React from "react";
import * as PropTypes from "prop-types";
import { reportsCurrencyFormatter } from "../../utils";

PreferredProgrammeSnapshotReportTable.propTypes = {
  tableData: PropTypes.shape({
    number_of_enquiries: PropTypes.number.isRequired,
    number_of_confirmed_bookings: PropTypes.number.isRequired,
    number_of_provisional_bookings: PropTypes.number.isRequired,
    number_of_cancelled_bookings: PropTypes.number.isRequired,
    number_of_denied_bookings: PropTypes.number.isRequired,
    value_of_confirmed_bookings: PropTypes.number.isRequired,
    value_of_provisional_bookings: PropTypes.number.isRequired,
    value_of_cancelled_bookings: PropTypes.number.isRequired,
    value_of_denied_bookings: PropTypes.number.isRequired,
    total_percentage_savings: PropTypes.number.isRequired,
  }),
};

function PreferredProgrammeSnapshotReportTable({ tableData }) {
  return (
    <ul className="list-reset list-spaced">
      <li className="li-head">
        <strong>Enquiries</strong>
      </li>
      <li className="flex justify-between">
        <span>Number of enquiries</span>
        <strong>{tableData.number_of_enquiries}</strong>
      </li>
      <li className="flex justify-between">
        <span>Value of enquiries</span>
        <strong>
        {reportsCurrencyFormatter("GBP").format(tableData.value_of_enquiries)}
          </strong>
      </li>
      <li className="li-head">
        <strong>Confirmed</strong>
      </li>
      <li className={"flex justify-between"}>
        <span>Number of confirmed bookings</span>
        <strong>{tableData.number_of_confirmed_bookings}</strong>
      </li>
      <li className="flex justify-between">
        <span>Value of confirmed bookings</span>
        <strong>
          {reportsCurrencyFormatter("GBP").format(tableData.value_of_confirmed_bookings)}
        </strong>
      </li>
      <li className="li-head">
        <strong>Provisional</strong>
      </li>
      <li className="flex justify-between">
        <span>Number of provisional bookings</span>
        <strong>{tableData.number_of_provisional_bookings}</strong>
      </li>
      <li className="flex justify-between">
        <span>Value of provisional bookings</span>
        <strong>{reportsCurrencyFormatter("GBP").format(tableData.value_of_provisional_bookings)}</strong>
      </li>
      <li className="li-head">
        <strong>Cancelled</strong>
      </li>
      <li className="flex justify-between">
        <span>Number of cancelled bookings</span>
        <strong>{tableData.number_of_cancelled_bookings}</strong>
      </li>
      <li className="flex justify-between">
        <span>Value of cancelled bookings</span>
        <strong>
          {reportsCurrencyFormatter("GBP").format(tableData.value_of_cancelled_bookings)}
        </strong>
      </li>
      <li className="li-head">
        <strong>Denied</strong>
      </li>
      <li className="flex justify-between">
        <span>Number of denied bookings</span>
        <strong>{tableData.number_of_denied_bookings}</strong>
      </li>
      <li className="flex justify-between">
        <span>Value of denied bookings</span>
        <strong>
          {reportsCurrencyFormatter("GBP").format(tableData.value_of_denied_bookings)}
        </strong>
      </li>
      <li className="li-head">
        <strong>Total</strong>
      </li>
      <li className="flex justify-between">
        <span>Cost Savings (Confirmed Events)</span>
        <strong>{tableData.total_percentage_savings}%</strong>
      </li>
      <li className="flex justify-between">
        <span>Conversion Rate</span>
        <strong>{tableData.conversion_rate}%</strong>
      </li>
    </ul>
  );
}

export default PreferredProgrammeSnapshotReportTable;
